// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__CQXcH","name":"Affair_name__D0HV5","closeButton":"Affair_closeButton__m9iPk"};